export const FLOW_NAMES = {
  SIGN_IN: "signIn",
  SIGN_UP: "signUp",
  FORGOT_PASSWORD: "forgotPassword",
};

export const SIGN_IN_STEP_NAMES = {
  SN_GET_MYINFO_REDIRECT_URL: "SN_GET_MYINFO_REDIRECT_URL",
  SN_GET_MYINFO_DETAILS: "SN_GET_MYINFO_DETAILS",
  SN_UPDATE_MYINFO_MOBILE_NUMBER: "SN_UPDATE_MYINFO_MOBILE_NUMBER",
  SN_TRIGGER_SMS_OTP: "SN_TRIGGER_SMS_OTP",
  SN_VERIFY_SMS_OTP: "SN_VERIFY_SMS_OTP",
  SN_TRIGGER_EMAIL_OTP: "SN_TRIGGER_EMAIL_OTP",
  SN_VERIFY_EMAIL_OTP: "SN_VERIFY_EMAIL_OTP",
  SN_VIEW_PROFILE: "SN_VIEW_PROFILE",
};

export const SIGN_UP_STEP_NAMES = {
  REG_MYINFO_FETCH_REDIRECTION_URL: "REG_MYINFO_FETCH_REDIRECTION_URL",
  REG_MYINFO_FETCH_USER_DATA: "REG_MYINFO_FETCH_USER_DATA",
  REG_MYINFO_VERIFY_CUSTOMER: "REG_MYINFO_VERIFY_CUSTOMER",
  REG_MYINFO_CREATE_GREATID: "REG_MYINFO_CREATE_GREATID",
  REG_BASIC_TO_MAIN_UPGRADE: "REG_BASIC_TO_MAIN_UPGRADE",
  REG_TRIGGER_SMS_OTP: "REG_TRIGGER_SMS_OTP",
  REG_VERIFY_MEMBERID: "REG_VERIFY_MEMBERID",
  REG_VERIFY_SMS_OTP: "REG_VERIFY_SMS_OTP",
  REG_CREATE_MEMBERID: "REG_CREATE_MEMBERID",
};

export const FORGOT_PASSWORD_STEP_NAMES = {
  FP_GET_MYINFO_REDIRECT_URL: "FP_GET_MYINFO_REDIRECT_URL",
  FP_GET_MYINFO_DETAILS: "FP_GET_MYINFO_DETAILS",
  FP_UPDATE_MYINFO_MOBILE_NUMBER: "FP_UPDATE_MYINFO_MOBILE_NUMBER",
  FP_RESET_PASSWORD: "FP_RESET_PASSWORD",
  FP_TRIGGER_SMS_OTP: "FP_TRIGGER_SMS_OTP",
  FP_VERIFY_SMS_OTP: "FP_VERIFY_SMS_OTP",
};

export const ERROR_CODES = {
  MIDERR_001: "MIDERR_001",
  MIDERR_002: "MIDERR_002",
  MIDERR_003: "MIDERR_003",
  MIDERR_004: "MIDERR_004",
  MIDERR_005: "MIDERR_005",
  MIDERR_006: "MIDERR_006",
  MIDERR_007: "MIDERR_007",
  MIDERR_008: "MIDERR_008",
  MIDERR_009: "MIDERR_009",
  MIDERR_010: "MIDERR_010",
  MIDERR_011: "MIDERR_011",
  MIDERR_012: "MIDERR_012",
  MIDERR_013: "MIDERR_013",
  MIDERR_014: "MIDERR_014",
  MIDERR_015: "MIDERR_015",
  MIDERR_016: "MIDERR_016",
  MIDERR_017: "MIDERR_017",
  MIDERR_018: "MIDERR_018",
  MIDERR_019: "MIDERR_019",
  MIDERR_020: "MIDERR_020",
  MIDERR_021: "MIDERR_021",
  MIDERR_022: "MIDERR_022",
  MIDERR_023: "MIDERR_023",
  MIDERR_024: "MIDERR_024",
  MIDERR_025: "MIDERR_025",
  MIDERR_026: "MIDERR_026",
  MIDERR_027: "MIDERR_027",
  MIDERR_028: "MIDERR_028",
  MIDERR_029: "MIDERR_029",
  MIDERR_030: "MIDERR_030",
  MIDERR_031: "MIDERR_031",
  MIDERR_032: "MIDERR_032",
  MIDERR_033: "MIDERR_033",
  MIDERR_034: "MIDERR_034",
  MIDERR_035: "MIDERR_035",
  MIDERR_036: "MIDERR_036",
  MIDERR_037: "MIDERR_037",
  MIDERR_038: "MIDERR_038",
  MIDERR_043: "MIDERR_043",
  MIDERR_044: "MIDERR_044",
  MIDERR_045: "MIDERR_045",
  MIDERR_046: "MIDERR_046",
  MIDERRUI_501: "MIDERRUI_501",
  MIDERRUI_503: "MIDERRUI_503",
  MIDERRUI_601: "MIDERRUI_601",
};

export const VUEX_COMMON = {
  SET_STATUS: "SET_STATUS",
  SET_IS_FETCHING: "SET_IS_FETCHING",
  SET_RESPONSE: "SET_RESPONSE",
  SHOW_ALERT: "alert/SHOW_ALERT",
  REQUEST_ID_STORAGE_KEY: "requestID",
  LOGGED_IN_STORAGE_KEY: "loggedIn",
};

export const COUNTRY_CODES = {
  SG: "sg",
  MY: "my",
};
